import { TrackingDescriptionResponseType } from 'api/trackingDescription';
import { TrackingDescriptionIDType } from 'defs/tracking';
import { CLOSE, LOAD, LOAD_FAILURE, LOAD_SUCCESS, OPEN } from './trackingDescription.actionTypes';

export const actionCreators = {
	doRequestDescriptions: () => ({
		type: LOAD,
	}),
	doRequestDescriptionsSuccess: (descriptions: TrackingDescriptionResponseType[]) => {
		return {
			type: LOAD_SUCCESS,
			descriptions,
		};
	},
	doRequestDescriptionsFailure: (error: Error) => ({
		type: LOAD_FAILURE,
		error,
	}),
	doOpenDescription: (descriptionId: TrackingDescriptionIDType) => ({
		type: OPEN,
		descriptionId,
	}),
	doCloseDescription: (descriptionId: TrackingDescriptionIDType) => ({
		type: CLOSE,
		descriptionId,
	}),
};

export type TrackingDescriptionActionType =
	| ReturnType<typeof actionCreators.doRequestDescriptions>
	| ReturnType<typeof actionCreators.doRequestDescriptionsSuccess>
	| ReturnType<typeof actionCreators.doRequestDescriptionsFailure>
	| ReturnType<typeof actionCreators.doOpenDescription>
	| ReturnType<typeof actionCreators.doCloseDescription>;
